import { Component, Inject, OnInit } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { AuthService } from '../auth/auth.service';
import { Router } from '@angular/router';
@Component({
  selector: 'app-forcelogout',
  templateUrl: './forcelogout.component.html',
  styleUrls: ['./forcelogout.component.scss']
})
export class ForcelogoutComponent implements OnInit {
  logoutForm: FormGroup;
  submitted: boolean;
  sentOtp: boolean;
  constructor(
    public dialogRef: MatDialogRef<ForcelogoutComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private formBuilder: FormBuilder,
    private auths: AuthService,
    private router: Router,
  ) {
    this.logoutForm = this.formBuilder.group({
      otp: ['', Validators.required],
      mobileNumber: ['', Validators.required],
      email: ['', Validators.required],
      emailotp: ['', Validators.required],
    });
  }

  ngOnInit(): void {
    console.log(this.data);
  }
  get f() { return this.logoutForm.controls; }
  getOtp() {

    this.submitted = true;

    // stop here if form is invalid
    if (!this.logoutForm.value.mobileNumber) {
      return;
    }
    const reqParams = {
      email: this.logoutForm.value.email,
      mobile: this.logoutForm.value.mobileNumber,
    }
    this.auths.forcelogoutgetOtp(reqParams).subscribe((data: any) => {
      if (data.data || data.data.status == 200) {
      this.sentOtp = true;
      }
    })
  }
  validateOpt() {
    this.submitted = true;

    // stop here if form is invalid
    if (!this.logoutForm.value.otp) {
      return;
    }
    const valotpParams = {
      otp: this.logoutForm.value.emailotp,
      walletOtp: this.logoutForm.value.otp
    }
    this.auths.validateOtp(valotpParams).subscribe((data: any) => {
      this.dialogRef.close();
      if (data && data['data'].email) {
        this.router.navigate(['/dashboard']);
      }
    });
  }
  closepopUp() {
    this.dialogRef.close();
  }
}
